import { downloadFilePost, get, post, put } from 'utils/api';
import { CategoryModel } from './listCategory_services';

export type ProductModel = {
  stt: number;
  productId: string;
  parentCategoryName: string;
  categoryName: string;
  categoryDetailName: string;
  categoryDetail2Name: string;
  productCode: string;
  productName: string;
  serial: string;
  hasRouting: boolean;
  actived: boolean;
  bin: string;
  currentBin: string;
  locationNote: string;
  specification: string;
  size: string;
  status: string;
  printMoldFilm: string;
  printMoldName: string;
  knifeType: string;
  equipmentType: string;
  productNum: string;
  vendor: string;
  oldCode: string;
  stampQuantity: string;
  currentStampQuantity: number;
  moldTest: string;
  ghiChu: string;
  // sloc là kho khuôn ngoài màn detail
  sloc: string;
};

export type ProductModelDetail = {
  productCode: string;
  productName: string;
  categoryId: string | null;
  parentCategory: CategoryModel | null;
  parentCategoryId: string | null;
  categoryDetailId: string | null;
  categoryDetail2Id: string | null;
  hasRouting: boolean | null;
  actived: boolean | null;
  statusMold: string | null;
  isExpiredDate: boolean | null;
  isTooManyTimes: boolean | null;
  bin: string;
  currentBin: string;
};

// data response
export type ProductResponse = {
  data: Array<ProductModel>;
  message: string;
  isSuccess: boolean;
  recordsTotal: number;
  resultsCount: number;
  pagesCount: number;
};

// cong doan san pham routing product
export type productRouting = {
  routingVersion: string;
  productCode: string;
  productName: string;
  orderIndex: number;
  stepCode: string;
  stepName: string;
  productionGuide: string;
  estimateComplete: number;
  ratedTime: string;
  molds: [string];
  productPerPage: number;
};
// Product detail
export type ProductDetail = Partial<{
  // kiểu dáng sản phẩm
  categoryDetail2Name: string;

  // Mã phân cấpMã
  parentCategoryName: string;
  // mã nhóm sản phẩm
  categoryName: string;
  // Mã nhóm sản phẩm chi tiết
  categoryDetailName: string;
  // Mã sản phẩm
  productCode: string;
  // Tên sản phẩm
  productName: string;
  // số serial
  serial: string;
  //  mô tả
  description: string;
  // Đơn vị tính
  unit: string;
  // mã bản vẽ khuôn
  moldDrawCode: string;
  // tình trạng
  status: string;
  printMoldFilm: string;
  // Mã film chụp bản
  printMoldName: string;
  bin: string;
  crrBin: string;
  locationNote: string;
  lastMaintenanceDate: any;
  buyDate: any;
  testDate: any;
  usedDate: any;
  moldTest: string | null;
  lastMaintenanceDateStr: string;
  maintenanceAlert: number;
  // Ngày bảo trì tiếp theo
  nextMaintenanceDate: string;
  stampQuantity: number;
  // so lan dap hien tai
  currentStampQuantity: number;
  // canh bao so lan dap
  stampQuantityAlert: number;

  // trang thai
  actived: boolean;
  isMold: boolean;
  productRoutings: Array<productRouting>;
  // Kích thước/Quy cách
  specification: string;
  // Kích thước/Quy cách SP
  size: string;
  // Loại dao
  knifeType: string;
  // Loại máy bế
  equipmentType: string;
  // Số SP/Khuôn
  productNum: string;
  // Tên nhà cung cấp
  vendor: string;
  // Mã cũ
  oldCode: string;
  // Ghi chú
  ghiChu: string;
}>;

export type ProductDetailResponse = {
  data: ProductDetail;
  isSuccess: boolean;
  message: string;
};
export type editProductResponse = {
  isSuccess: boolean;
  message: string;
};

export interface IProductServices {
  getListProduct(data: any): Promise<ProductResponse>;
  getProductDetailById(id: string): Promise<ProductDetailResponse>;
  editProduct(data: any): Promise<editProductResponse>;

  // xuất excel product
  exportExcelProduct(data: object): Promise<void>;
}

export function createProductServices(): IProductServices {
  return {
    getListProduct: async (data: any): Promise<ProductResponse> => {
      return (await post(`MasterData/Product/get-list-product`, data)).data;
    },
    getProductDetailById: async (id: string): Promise<ProductDetailResponse> => {
      return (await get(`MasterData/Product/get-product-detail?productId=${id}`)).data;
    },
    editProduct: async (data: any): Promise<editProductResponse> => {
      return (await put(`MasterData/Product/edit-product-detail`, data)).data;
    },
    exportExcelProduct: async (data: object) => {
      await downloadFilePost(`MasterData/Product/export-excel-product`, data);
    },
  };
}
